/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Registry_Ku_KodInputs */

const cs_property_registry_ku_kod = /** @type {(inputs: Property_Registry_Ku_KodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kód k.ú.`)
};

const en_property_registry_ku_kod = /** @type {(inputs: Property_Registry_Ku_KodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cadastral area code`)
};

/**
* | output |
* | --- |
* | "Cadastral area code" |
*
* @param {Property_Registry_Ku_KodInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_registry_ku_kod = /** @type {((inputs?: Property_Registry_Ku_KodInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Registry_Ku_KodInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_registry_ku_kod(inputs)
	return cs_property_registry_ku_kod(inputs)
});